module.exports = __webpack_public_path__ + "img/record.d0289dc0.jpg";